import { initComponents } from "./../utils/initComponents";
import { initLazyLoading } from "../utils/initLazyLoading";
import { onLoadEvents } from "../utils/onLoadEvents";

import Header from "./../components/Header";
import AccordionGrid from "./../components/AccordionGrid";
import ArticlePromoCarousel from "./../components/ArticlePromoCarousel";
import VideoCarousel from "./../components/VideoCarousel";
import VModal from "./../components/VModal";
import HomepageHero from "../components/HomepageHero";
import FeaturedStats from "../components/FeaturedStats";
import HomepageScrollingExperience from "../components/HomepageScrollingExperience";
import AnimationsController from "../components/AnimationsController";
import VerticalVideoCarousel from "../components/VerticalVideoCarousel";
import StatGrid from "../components/StatGrid";
import ArticleVideoCarousel from "../components/ArticleVideoCarousel";
import HorizontalAccordion from "../components/HorizontalAccordion";
import Accordion from "../components/Accordion";
import Carousel from "../components/Carousel";
import QuoteCarousel from "../components/QuoteCarousel";
import StackedCards from "../components/StackedCards";
import MapFeature from "../components/MapFeature";
import ArticleGeneral from "../components/ArticleGeneral";
import ArticleSeries from "../components/ArticleSeries";
import BioModal from "../components/BioModal";
import LeadershipGrid from "../components/LeadershipGrid";
import TabbedFeature from "../components/TabbedFeature";
import CookieBanner from "../components/CookieBanner";

// Vue
import PostIndex from "./../components/PostIndex.vue";
import ArchiveIndex from "./../components/ArchiveIndex.vue";
import { createApp } from "vue";

/**
 * Global variables
 */
window.breakpoint = 768;

/**
 * Init App
 */
const APP = {};
APP.helpers = {
  initComponents: (elem) => initComponents(elem, APP),
  initLazyLoading: (APP) => initLazyLoading(APP),
  onLoadEvents: (APP) => onLoadEvents(APP),
};

/**
 * Page components
 * <elem data-component="<component name>">
 */
APP.components = {
  Header: (elem) => new Header(elem, APP).init(),
  AccordionGrid: (elem) => new AccordionGrid(elem, APP).init(),
  VideoCarousel: (elem) => new VideoCarousel(elem, APP).init(),
  ArticlePromoCarousel: (elem) => new ArticlePromoCarousel(elem, APP).init(),
  HomepageHero: (elem) => new HomepageHero(elem, APP).init(),
  VModal: (elem) => new VModal(elem, APP).init(),
  FeaturedStats: (elem) => new FeaturedStats(elem, APP).init(),
  HomepageScrollingExperience: (elem) => new HomepageScrollingExperience(elem, APP).init(),
  AnimationsController: (elem) => new AnimationsController(elem, APP).init(),
  VerticalVideoCarousel: (elem) => new VerticalVideoCarousel(elem, APP).init(),
  StatGrid: (elem) => new StatGrid(elem, APP).init(),
  ArticleVideoCarousel: (elem) => new ArticleVideoCarousel(elem, APP).init(),
  HorizontalAccordion: (elem) => new HorizontalAccordion(elem, APP).init(),
  Accordion: (elem) => new Accordion(elem, APP).init(),
  Carousel: (elem) => new Carousel(elem, APP).init(),
  QuoteCarousel: (elem) => new QuoteCarousel(elem, APP).init(),
  StackedCards: (elem) => new StackedCards(elem, APP).init(),
  MapFeature: (elem) => new MapFeature(elem, APP).init(),
  ArticleGeneral: (elem) => new ArticleGeneral(elem, APP).init(),
  ArticleSeries: (elem) => new ArticleSeries(elem, APP).init(),
  BioModal: (elem) => new BioModal(elem, APP).init(),
  LeadershipGrid: (elem) => new LeadershipGrid(elem, APP).init(),
  TabbedFeature: (elem) => new TabbedFeature(elem, APP).init(),
  CookieBanner: (elem) => new CookieBanner(elem, APP).init(),
};

/**
 * Init Vue based on the templates
 * This is for the custom post type archive page
 * See component-post_index.twig
 */
if (document.querySelector("#vue-post-index")) {
  const container = createApp({});
  container.component("post-index", PostIndex);
  container.mount("#vue-post-index");
}

/**
 * This is for the term archive page, search page
 * See archive.twig, search.twig
 */
if (document.querySelector("#vue-archive-index")) {
  const container = createApp({});
  container.component("archive-index", ArchiveIndex);
  container.mount("#vue-archive-index");
}

export default APP;
